export default "__VITE_ASSET__BmHd24jG__"